export default __webpack_public_path__ + "static/media/12.c988f3a9.png";